import { useParams } from "react-router";

import { FlowEditor } from "./flow-editor";

export default function FlowEditorPage() {
  const { id } = useParams();
  return <FlowEditor flowId={id!} />;
}
